import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private availableLanguages = [
    { code: 'en', name: 'English', nativeName: 'English', dbValue: 'English' }, 
    { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', dbValue: 'Hindi' },       
    { code: 'mr', name: 'Marathi', nativeName: 'मराठी', dbValue: 'Marathi' },  
    { code: 'bn', name: 'Bangla', nativeName: 'বাংলা', dbValue: 'Bengali' },   
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', dbValue: 'Tamil' },      
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', dbValue: 'Telugu' }    
  ];

  private currentLanguage = new BehaviorSubject<string>('en');
  currentLanguage$ = this.currentLanguage.asObservable();

  constructor() {
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang) {
      this.currentLanguage.next(savedLang);
    }
  }

  getAvailableLanguages() {
    return this.availableLanguages;
  }

  getCurrentLanguage() {
    return this.currentLanguage.value;
  }

  getCurrentLanguageForDB(): string {
    const lang = this.availableLanguages.find(l => l.code === this.currentLanguage.value);
    return lang ? lang.dbValue : 'English'; 
  }

  setLanguage(langCode: string) {
    this.currentLanguage.next(langCode);
    localStorage.setItem('preferredLanguage', langCode);
  }

  getLanguageName(langCode: string): string {
    const lang = this.availableLanguages.find(l => l.code === langCode);
    return lang ? lang.name : 'English';
  }

  // Database value se code find karne ke liye
  getCodeFromDBValue(dbValue: string): string {
    if (!dbValue) return 'en';
    
    // ✅ Case-insensitive comparison
    const lang = this.availableLanguages.find(l => 
      l.dbValue.toLowerCase() === dbValue.toLowerCase()
    );
    return lang ? lang.code : 'en';
  }
}